export default __webpack_public_path__ + "static/media/CLOSE.0bd0945d.svg";